import LeadCompletedForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadCompletedForm"
import LeadNegotiatingForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadNegotiatingForm"
import LeadQualifyingFinancialReviewForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadQualifyingFinancialReviewForm"
import LeadQualifyingForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadQualifyingForm"
import LeadQualifyingManagementReviewForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadQualifyingManagementReviewForm"
import LeadQuotingFinalizationForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadQuotingFinalizationForm"
import LeadQuotingForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadQuotingForm"
import LeadQuotingManagementReviewForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadQuotingManagementReviewForm"
import LeadRegisteredForm from "@/features/privateCompanyLeadsFunnel/components/leadFormStates/LeadRegisteredForm"

export const leadFormStateOptions = [
  {
    value: 'registered',
    comp: LeadRegisteredForm,
  },
  {
    value: 'qualifying',
    comp: LeadQualifyingForm,
  },
  {
    value: 'qualifying_management_review',
    comp: LeadQualifyingManagementReviewForm,
  },
  {
    value: 'qualifying_finantial_review',
    comp: LeadQualifyingFinancialReviewForm,
  },
  {
    value: 'quoting',
    comp: LeadQuotingForm,
  },
  {
    value: 'quoting_management_review',
    comp: LeadQuotingManagementReviewForm,
  },
  {
    value: 'quoting_client_review',
    comp: LeadQuotingManagementReviewForm,
  },
  {
    value: 'quoting_finalization',
    comp: LeadQuotingFinalizationForm,
  },
  {
    value: 'negotiating',
    comp: LeadNegotiatingForm,
  },
  {
    value: 'completed',
    comp: LeadCompletedForm,
  },
]